import {
    CREATE_JOB_YARN_RETURN,
    DELETE_JOB_YARN_RETURN,
    GET_JOB_YARN_RETURN,
    JOB_YARN_RETURN_REQUEST,
    JOB_YARN_RETURN_REQUEST_FAILURE,
    UPDATE_JOB_YARN_RETURN,
    GET_JOB_YARN_RETURNS_PAGE,
    JOB_YARN_RETURN_REQUEST_SUCCESS
  } from "../types/job-yarn-return-types";
  
  const initialState = {
    jobYarnReturn: [],
    jobYarnReturnsPage: [],
    loading: false,
    error: null,
  };
  
  const jobYarnReturnReducer = (state = initialState, action) => {
    switch (action.type) {
      case JOB_YARN_RETURN_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        }
      }
      case GET_JOB_YARN_RETURN: {
        return {
          ...state,
          jobYarnReturn: [...action.payload],
          loading: false,
          error: null
        }
      }
      case GET_JOB_YARN_RETURNS_PAGE: {
        const { data, total, page, pageSize, search, where } = action.payload || {};
        return {
          ...state,
          jobYarnReturnsPage: [...data],
          total,
          page,
          pageSize,
          search: search || '',
          where: where || {},
          loading: false,
          error: null
        }
      }
      case CREATE_JOB_YARN_RETURN:
        return {
          ...state,
          jobYarnReturn: [action.payload, ...state.jobYarnReturn],
          loading: false,
          error: null
        };
      case UPDATE_JOB_YARN_RETURN:
        const jobYarnReturnData = state.jobYarnReturn.slice(0);
        const uIndex = jobYarnReturnData.findIndex((data) => data.id === action.payload.id);
        jobYarnReturnData.splice(uIndex, 1, { ...action.payload.data });
        
        return {
          ...state,
          jobYarnReturn: [ ...jobYarnReturnData ],
          loading: false,
          error: null
        };
      case DELETE_JOB_YARN_RETURN:
        const jobYarnReturn = state.jobYarnReturn?.slice(0);
        const index = jobYarnReturn.findIndex((data) => data.id === action.id);
        if (index > -1) {
          jobYarnReturn.splice(index, 1);
        }
        return {
          ...state,
          jobYarnReturn: [...jobYarnReturn],
          loading: false,
          error: null
        }
      case JOB_YARN_RETURN_REQUEST_SUCCESS: {
        return {
          ...state,
          loading: false,
          error: null
        }
      }
      case JOB_YARN_RETURN_REQUEST_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        }
      }
      default:
        return state;
    }
  };
  
  export default jobYarnReturnReducer;
  